import { render, staticRenderFns } from "./memopelunasanblacklist.vue?vue&type=template&id=ed5abf2e&scoped=true&"
import script from "./memopelunasanblacklist.vue?vue&type=script&lang=js&"
export * from "./memopelunasanblacklist.vue?vue&type=script&lang=js&"
import style0 from "./memopelunasanblacklist.vue?vue&type=style&index=0&id=ed5abf2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5abf2e",
  null
  
)

export default component.exports